// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__QZrAM","title":"Header_title__2ybIW","left":"Header_left__2HkEu","clinicName":"Header_clinicName__2ryuk"};